<nav class="patient-nav" *ngIf="(user$ | async)?.isPatient" aria-label="Patient portal">
  <p class="patient-nav__eyebrow page__eyebrow">My Portal</p>
  <ul class="patient-nav__list">
    <li *ngFor="let item of items">
      <a
        class="patient-nav__link"
        [routerLink]="item.link"
        [class.patient-nav__link--active]="isActive(item)"
      >
        <i class="pi {{ item.icon }}" aria-hidden="true"></i>
        <span>{{ item.label }}</span>
      </a>
    </li>
  </ul>
</nav>
